export default function (Alpine) {
    Alpine.store('auth', {
        open: false,

        show() {
            this.open = true
            document.body.style.overflow = 'hidden'
        },

        hide() {
            this.open = false
            document.body.style.overflow = ''
        }
    })
}
